// extracted by mini-css-extract-plugin
export default {"JSONTypeStyle":"JSONTypeStyleA3dsh","jsonTypeStyle":"JSONTypeStyleA3dsh"};